module.exports = "pegasus/assets/themelp1/tickets/100.png";